import React, { useEffect, useState } from "react";
import thumb from "../assets/images/thumb-01.png";
import successIcon from "../assets/images/success-icon.gif";
import reviewIcon from "../assets/images/review-icon.png";
import cancelIcon from "../assets/images/cancel-icon.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl, imgUrl } from "./Helper/BaseUrl";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PriceDisplay from "./PriceDisplay";
import StarRating from "./Helper/StarRating";
const MyOrder = () => {
  const user = useSelector((state) => state.auth.user);
  const userId = user?.id;
  const isLoggedIn = localStorage.getItem("user");
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [orderList, setOrderList] = useState([]);

  const [formData, setFormData] = useState({
    reason: "",
    details: "",
    payment: "credit-card",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  // review form handling
  const [values, setValues] = useState({
    user_id: userId,
    title: "",
    rating: 0,
    description: "",
  });
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedStars, setSelectedStars] = useState(0);
  // Add a function to get title based on star rating
  const getStarTitle = (rating) => {
    switch (rating) {
      case 1:
        return "Poor Experience";
      case 2:
        return "Fair Product";
      case 3:
        return "Good Product";
      case 4:
        return "Excellent Choice";
      case 5:
        return "Outstanding Product";
      default:
        return "";
    }
  };
  const handleStarClick = (value) => {
    const reviewTitle = getStarTitle(value);
    setSelectedStars(value);
    setValues((prev) => ({
      ...prev,
      rating: value,
      title: reviewTitle,
    }));
  };

  const handleReviewChange = (e) => {
    setValues((prev) => ({ ...prev, description: e.target.value }));
  };
  const [imgFile, setImgFile] = useState(null);
  // console.log("reviews", values)

  const handleReviewSubmit = async (e, productId) => {
    // console.log("productId", productId)
    e.preventDefault();
    // console.log("reviews", values)
    const reviewData = new FormData();
    reviewData.append("prduct_id", currentProductId);
    reviewData.append("user_id", userId);
    reviewData.append("title", values.title);
    reviewData.append("rating", values.rating);
    reviewData.append("description", values.description);
    if (imgFile) {
      reviewData.append("review_images", imgFile);
    }
    try {
      const res = await axios.post(`${baseUrl}/review-store`, reviewData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.data.status) {
        toast.success(res.data.message);
        const reviewModalEl = document.getElementById("order-review");
        const reviewInstance =
          window.bootstrap.Modal.getInstance(reviewModalEl);
        reviewInstance.hide();
        setValues({
          prduct_id: "",
          user_id: "",
          title: "",
          rating: 0,
          description: "",
        });
        setImgFile(null);
        setSelectedStars(0);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      // console.log("error review submit", error);
      toast.error(error.message);
    }
  };

  // fetch order api
  const fetchOrderDetails = async () => {
    if (!userId) {
      // console.log("No user ID available");
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/users/${userId}/orders`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      // console.log("data in my order", data);
      setOrderList(data.responseObject.orders);
    } catch (error) {
      // console.log("Error fetching orders:", error.message);
      toast.error("Failed to fetch orders. Please try again later.");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };
  const navigate = useNavigate();
  //reorder
  const handleReorder = async (orderId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/order/users/${userId}/orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log("reorder", response);
      if (response.data.status) {
        // Navigate to checkout page with the reordered product data
        navigate("/checkout", {
          state: {
            reorderProducts: response.data.data,
            isReorder: true,
          },
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Reorder error:", error);
      toast.error("Failed to reorder. Please try again.");
    }
  };
  useEffect(() => {
    const modal = document.getElementById("order-review");
    modal?.addEventListener("show.bs.modal", (event) => {
      const button = event.relatedTarget;
      const productId = button.getAttribute("data-product-id");
      // console.log("productId", productId);
      setCurrentProductId(productId);
    });
  }, []);
  useEffect(() => {
    fetchOrderDetails();
    window.scrollTo(0, 0);
    // Ensure loader shows for at least 0.4 seconds
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  if (isPageLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      {/* Banner Section */}
      <section
        className="bg-light py-3 py-md-4 mb-3 mb-md-4"
        style={{ marginTop: "100px" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-12 text-center">
              <h3 className="mb-2">My Orders</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/" className="text-decoration-none">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    My Orders
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5">
        <div className="container">
          {isLoggedIn ? (
            <div className="row">
              <div className="col-12">
                {orderList && orderList.length > 0 ? (
                  <>
                    {/* Order Tabs - Made responsive */}
                    <ul className="nav nav-pills mb-3 mb-md-4 justify-content-center flex-wrap gap-2">
                      <li className="nav-item">
                        <button
                          className="nav-link active px-3 px-md-4 py-2"
                          data-bs-toggle="tab"
                          data-bs-target="#tab-01"
                          type="button"
                        >
                          <i className="fas fa-clock me-2"></i>Ongoing Orders
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className="nav-link px-3 px-md-4 py-2"
                          data-bs-toggle="tab"
                          data-bs-target="#tab-02"
                          type="button"
                        >
                          <i className="fas fa-list me-2"></i>All Orders
                        </button>
                      </li>
                    </ul>

                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="tab-01">
                        {orderList.map((order) => (
                          <div
                            key={order._id}
                            className="card border-0 shadow-sm rounded-3 mb-4"
                          >
                            {/* Order Header - Made responsive */}
                            <div className="card-header bg-white p-3">
                              <div className="row align-items-center">
                                <div className="col-12 col-md-6 mb-2 mb-md-0">
                                  <p className="text-muted small mb-1">
                                    ORDER PLACED
                                  </p>
                                  <p className="mb-0 fw-bold">
                                    {new Date(
                                      order.createdAt
                                    ).toLocaleDateString()}{" "}
                                    {new Date(
                                      order.createdAt
                                    ).toLocaleTimeString()}
                                  </p>
                                </div>
                                <div className="col-12 col-md-6">
                                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-end gap-2">
                                    <div className="text-start text-md-end">
                                      <p className="text-muted small mb-1">
                                        ORDER #{order._id}
                                      </p>
                                      <p className="fw-bold mb-0">
                                        ₹{Number(order.finalAmount).toFixed(2)}
                                      </p>
                                    </div>
                                    <Link
                                      to={`/orderdetails/${order._id}`}
                                      className="btn btn-outline-primary"
                                    >
                                      <i className="fas fa-truck me-2"></i>Track
                                      Order
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Products List - Made responsive */}
                            {order.products.map((prod) => (
                              <div
                                key={prod._id}
                                className="card-body border-bottom p-3"
                              >
                                <div className="row align-items-center">
                                  <div className="col-4 col-md-2 mb-3 mb-md-0">
                                    <img
                                      src={
                                        prod.productId?.productImages[0] ||
                                        thumb
                                      }
                                      alt={prod.productId?.productName}
                                      className="img-fluid rounded-3 object-fit-cover"
                                      style={{ height: "100px", width: "100%" }}
                                    />
                                  </div>
                                  <div className="col-8 col-md-7">
                                    <h6 className="mb-1">
                                      {prod.productId?.productName}
                                    </h6>
                                    <p className="text-muted mb-2">
                                      Weight: {prod.weightId?.weightInGrams}g
                                    </p>
                                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                      <del className="text-muted">
                                        ₹{prod.price.toFixed(2)}
                                      </del>
                                      <span className="fw-bold">
                                        ₹{prod.discountedPrice.toFixed(2)}
                                      </span>
                                      <span className="p-2 rounded badge text-white bg-success">
                                        {prod.productId?.discount_percentage}%
                                        OFF
                                      </span>
                                    </div>
                                    <div className="small text-muted">
                                      {/* Tax information - Made responsive */}
                                      <div className="d-flex flex-wrap gap-2">
                                        {order.shippingAddress.state ===
                                        "Maharashtra" ? (
                                          <>
                                            <span>
                                              CGST: ₹{prod.cgst?.toFixed(2)}
                                            </span>
                                            <span>
                                              SGST: ₹{prod.sgst?.toFixed(2)}
                                            </span>
                                            <span>
                                              Tax: ₹{prod.totalTax?.toFixed(2)}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span>
                                              IGST: ₹{prod.igst?.toFixed(2)}
                                            </span>
                                            <span>
                                              Tax: ₹{prod.totalTax?.toFixed(2)}
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3 mt-3 mt-md-0">
                                    <div className="text-start text-md-end">
                                      <div
                                        className={`p-2 rounded badge text-white bg-${
                                          order.status === "Cancelled"
                                            ? "danger"
                                            : "success"
                                        } mb-2`}
                                      >
                                        {order.status}
                                      </div>
                                      {order.status === "Delivered" && (
                                        <div>
                                          <div className="mb-2">
                                            <StarRating
                                              rating={
                                                prod.productId?.averageRating ||
                                                0
                                              }
                                            />
                                          </div>
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#order-review"
                                            data-product-id={
                                              prod.productId?._id
                                            }
                                          >
                                            <i className="fas fa-star me-1"></i>
                                            Write Review
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* Order Footer - Made responsive */}
                            <div className="card-footer bg-light p-3">
                              <div className="row">
                                <div className="col-12 col-md-6 mb-4 mb-md-0">
                                  <h6 className="text-muted mb-2">
                                    Delivery Address
                                  </h6>
                                  <p className="mb-0">
                                    {order.shippingAddress.street},<br />
                                    {order.shippingAddress.city},{" "}
                                    {order.shippingAddress.state},<br />
                                    {order.shippingAddress.postalCode},{" "}
                                    {order.shippingAddress.country}
                                  </p>
                                  {order.coupon && (
                                    <div className="mt-3">
                                      <h6 className="text-muted mb-1">
                                        Applied Coupon
                                      </h6>
                                      <div className="d-inline-block px-3 py-1 bg-success bg-opacity-10 rounded-pill">
                                        <span className="text-success">
                                          {order.coupon.couponName} (
                                          {order.coupon.discount}% OFF)
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="col-12 col-md-6">
                                  <div className="text-start text-md-end">
                                    <h6 className="text-muted mb-3">
                                      Price Details
                                    </h6>
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Total MRP</span>
                                      <span>
                                        ₹{Number(order.totalAmount).toFixed(2)}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Product Discount</span>
                                      <span className="text-success">
                                        -₹
                                        {(
                                          order.totalAmount -
                                          order.discountedAmount
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Delivery Charges</span>
                                      <span>₹{order.deliveryCharges}</span>
                                    </div>
                                    {order?.coupon && (
                                      <div className="d-flex justify-content-between mb-2">
                                        <span>
                                          Coupon ({order?.coupon?.coupenCode})
                                        </span>
                                        <span className="text-success">
                                          -₹
                                          {(
                                            (order.discountedAmount *
                                              order?.coupon?.discount) /
                                            100
                                          ).toFixed(2)}
                                        </span>
                                      </div>
                                    )}
                                    {order.shippingAddress.state ===
                                    "Maharashtra" ? (
                                      <>
                                        <div className="d-flex justify-content-between mb-2">
                                          <span>CGST</span>
                                          <span>
                                            ₹
                                            {Number(order.totalCGST).toFixed(2)}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                          <span>SGST</span>
                                          <span>
                                            ₹
                                            {Number(order.totalSGST).toFixed(2)}
                                          </span>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-between mb-2">
                                          <span>IGST</span>
                                          <span>
                                            ₹
                                            {Number(order.totalIGST).toFixed(2)}
                                          </span>
                                        </div>
                                      </>
                                    )}

                                    <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2">
                                      <span>Total Amount</span>
                                      <span>
                                        ₹{Number(order.finalAmount).toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* All Orders Tab Content - Similar structure as above */}
                      <div className="tab-pane fade" id="tab-02">
                        {orderList && orderList.length > 0 ? (
                          orderList &&
                          orderList.map((order, index) => {
                            return (
                              <div key={order._id} className="order-card">
                                <div className="order-card-head">
                                  <p className="mb-0">
                                    <span className="badges">
                                      Order: {order?._id}
                                    </span>{" "}
                                    Order Placed: {formatDate(order.createdAt)}
                                  </p>
                                  <Link
                                    to={`/orderdetails/${order._id}`}
                                    className="thm-btn"
                                  >
                                    Track order
                                  </Link>
                                </div>
                                {order?.products?.map((prod, index) => {
                                  return (
                                    <div
                                      key={prod._id}
                                      className="order-card-mddle"
                                    >
                                      <div className="order-card-bx">
                                        <img
                                          src={
                                            prod?.productId?.productImages
                                              ?.length > 0
                                              ? prod?.productId
                                                  ?.productImages[0]
                                              : thumb
                                          }
                                          alt="Product"
                                        />
                                        <div className="order-card-bx-content">
                                          <h6>
                                            {prod.productId?.productName} (
                                            {prod.weightId?.weightInGrams}g)
                                          </h6>
                                          <p>
                                            Price:{" "}
                                            <PriceDisplay
                                              priceUSD={prod.price}
                                            />
                                            <br /> QTY.: {prod.quantity}
                                          </p>
                                          <p className="price">
                                            Total Price:{" "}
                                            <PriceDisplay
                                              priceUSD={prod.totalPrice}
                                            />
                                          </p>
                                          <p className="price text-success">
                                            Discounted Price:{" "}
                                            <PriceDisplay
                                              priceUSD={
                                                prod.discountedTotalPrice
                                              }
                                            />
                                          </p>
                                          {order.shippingAddress.state ===
                                          "Maharashtra" ? (
                                            <>
                                              <p>
                                                CGST:{" "}
                                                <PriceDisplay
                                                  priceUSD={prod.cgst}
                                                />{" "}
                                                | SGST:{" "}
                                                <PriceDisplay
                                                  priceUSD={prod.sgst}
                                                />
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p>
                                                IGST:{" "}
                                                <PriceDisplay
                                                  priceUSD={prod.igst}
                                                />
                                              </p>
                                            </>
                                          )}
                                          <p>
                                            Total Tax:{" "}
                                            <PriceDisplay
                                              priceUSD={prod.totalTax}
                                            />
                                          </p>
                                        </div>
                                      </div>
                                      <div>
                                        <p className="mb-0 text-dark">
                                          Reviews
                                        </p>
                                        <p className="rating mb-0">
                                          <span className="fas fa-star" />
                                          <StarRating
                                            rating={
                                              prod?.productId?.averageRating ||
                                              0
                                            }
                                          />
                                        </p>
                                        <button
                                          className="txt-org"
                                          data-bs-toggle="modal"
                                          data-bs-target="#order-review"
                                          data-product-id={prod._id}
                                        >
                                          Write a Review
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                                <div className="order-card-bttm">
                                  <p className="mb-0">
                                    Order Placed: {formatDate(order.order_date)}{" "}
                                    {order.shipped_date &&
                                      order.shipped_date !== "00:00" && (
                                        <span>| {order.shipped_date}</span>
                                      )}{" "}
                                    {order.delivery_time &&
                                      order.delivery_time !== "00:00" && (
                                        <span>|{order.delivery_time}</span>
                                      )}
                                  </p>
                                  <div>
                                    {/* <a href="javascript:void(0);" className="thm-btn dark me-2">
                                                                      Details
                                                                  </a> */}
                                    <div className="status-text me-3">
                                      {" "}
                                      <p
                                        className={`mb-0 ${
                                          order?.status === "Cancelled"
                                            ? "text-danger"
                                            : "text-success"
                                        } fw-600`}
                                      >
                                        <em className="fas fa-circle me-1" />
                                        {order.status}
                                      </p>
                                    </div>

                                    {/* <Link to="#" onClick={() => handleReorder(order._id)} className="thm-btn">
                                                                      Reorder
                                                                  </Link> */}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <h2 className="text-center">
                            {" "}
                            {isLoggedIn
                              ? "No Orders"
                              : "Please login to view order "}{" "}
                          </h2>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center py-5">
                    <div className="mb-4">
                      <i className="fas fa-shopping-bag fa-4x text-muted"></i>
                    </div>
                    <h4 className="mb-3">No Orders Yet</h4>
                    <p className="text-muted mb-4">
                      Start shopping to see your orders here!
                    </p>
                    <Link to="/" className="btn btn-primary px-4 py-2">
                      <i className="fas fa-shopping-cart me-2"></i>Continue
                      Shopping
                    </Link>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center py-5">
              <div className="mb-4">
                <i className="fas fa-user-lock fa-4x text-muted"></i>
              </div>
              <h4 className="mb-3">Please Login</h4>
              <p className="text-muted mb-4">
                Login to access your order history
              </p>
              {/* <Link to="/login" className="btn btn-primary px-4 py-2">
                <i className="fas fa-sign-in-alt me-2"></i>Login
              </Link> */}
            </div>
          )}
        </div>
      </section>

      {/* cancel-order-start */}
      <div
        className="modal fade cancel-modal"
        id="cancel-order"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Cancel Order
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <img src={cancelIcon} className="img-90" alt="cancelIcon" />
              </div>
              <form action="" onSubmit={handleSubmit}>
                <div className="custom-frm-bx">
                  <label htmlFor="">Reason for Cancellation</label>
                  <select
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    id=""
                    className="form-select"
                  >
                    <option value="">My Reason is not listed</option>
                    <option value="reason1">Reason1</option>
                    <option value="reson2">Reason2</option>
                  </select>
                </div>
                <div className="custom-frm-bx">
                  <label htmlFor="">Write Details</label>
                  <textarea
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                    className="form-control height-100"
                    // defaultValue={""}
                  />
                </div>
                <div className="payment">
                  <h5 className="fz-16 fw-600 mb-3">Choose a Refund mode</h5>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="pay-01"
                      name="payment"
                      value="credit-card"
                      checked={formData.payment === "credit-card"}
                      onChange={handleChange}
                      // defaultChecked=""
                    />
                    <label className="form-check-label" htmlFor="pay-01">
                      {" "}
                      Debit/ Credit Card{" "}
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      value="gpay"
                      checked={formData.payment === "gpay"}
                      onChange={handleChange}
                      id="pay-02"
                    />
                    <label className="form-check-label" htmlFor="pay-02">
                      G PAY
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      value="phonepe"
                      checked={formData.payment === "phonepe"}
                      onChange={handleChange}
                      id="pay-03"
                    />
                    <label className="form-check-label" htmlFor="pay-03">
                      Phone Pe
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      value="twint"
                      checked={formData.payment === "twint"}
                      onChange={handleChange}
                      id="pay-04"
                    />
                    <label className="form-check-label" htmlFor="pay-04">
                      Twint
                    </label>
                  </div>
                  <button
                    type="submit"
                    className="thm-btn w-100 text-center danger"
                    data-bs-toggle="modal"
                    data-bs-target="#cancel-request"
                  >
                    Proceed
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* cancel-order-end */}
      {/* order-cancel-success-start */}
      <div
        className="modal fade cancel-modal"
        id="cancel-request"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={successIcon} alt="successicon" />
              <p className="text-center text-success fz-20 fw-600 mb-3">
                Cancel Request submitted Successfully
              </p>
              <button className="thm-btn" data-bs-dismiss="modal">
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* order-cancel-success-end */}
      {/*order-review-start */}
      <div
        className="modal fade cancel-modal"
        id="order-review"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Rating &amp; Reviews
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <img src={reviewIcon} className="img-90" alt="reviewIcon" />
              </div>
              <form
                action=""
                onSubmit={(e) => handleReviewSubmit(e, values.prduct_id)}
              >
                <div className="custom-frm-bx">
                  <label htmlFor="">Rate this product</label>
                  <ul id="stars" className="star-list">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <li
                        key={star}
                        className={`star ${
                          selectedStars >= star ? "selected" : ""
                        }`}
                        title={
                          star === 1
                            ? "Poor"
                            : star === 2
                            ? "Fair"
                            : star === 3
                            ? "Good"
                            : star === 4
                            ? "Excellent"
                            : "WOW!!!"
                        }
                        onClick={() => handleStarClick(star)}
                      >
                        <i className="fas fa-star fa-fw" />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="custom-frm-bx">
                  <label htmlFor="">About This product</label>
                  <textarea
                    name="description"
                    value={values.description}
                    onChange={handleReviewChange}
                    className="form-control height-100"
                    defaultValue={""}
                  />
                </div>
                <div className="custom-frm-bx image-upload">
                  <label htmlFor="image">
                    <i className="far fa-image me-2" />
                    Add Photos
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setImgFile(e.target.files[0])}
                    id="image"
                  />
                  <br />
                  {imageLoading && imgFile && (
                    <div className="loader">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                  {imgFile && (
                    <img
                      src={URL.createObjectURL(imgFile)}
                      width={100}
                      height={100}
                      onLoad={() => setImageLoading(false)}
                      alt="avtar"
                    />
                  )}
                </div>
                <div className="custom-frm-bx">
                  <button
                    type="submit"
                    className="thm-btn dark w-100 text-center"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* order-review-end */}
    </>
  );
};

export default MyOrder;
